import React, { Component, Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'
import { Typography } from '@material-ui/core'
import Select from 'react-select'
import Button from '@material-ui/core/Button'
import CustomerDetailsCard from '../../Modules/CustomerDetailsCard'
import SubscriptionDetails from './subscriptionDetails.jsx'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import moment from 'moment'
import getLoginId from '../../../utils/getLoginId'
import axios from 'axios'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      loginId
    }
  }
`

const GET_CLIENT = gql`
  query clientDetail($id: Int) {
    clientDetail(loginId: $id) {
      id
      clientName
      contactPerson
      address
      city
      expiryDate
      status
      state {
        zone_id
      }
      country {
        country_id
      }
      email
      contactNumber
      login {
        username
      }
      billingMode {
        id
      }
      pincode
      panNumber
      type
    }
  }
`

const ADD_SUBSCRIPTION = gql`
  mutation addSubscriptions(
    $clientLoginId: Int!
    $partnerLoginId: Int!
    $billingFrequencyId: Int!
    $deviceModelId: Int!
    $deviceQuantity: Int!
    $accessoryTypeId: Int
    $accessoryQuantity: Int
    $serviceProviderId: Int
    $simQuantity: Int
    $softwareQuantity: Int!
    $salesRemarks: String
    $hardwareCharges: Int!
    $accessoryCharges: Int
    $simCharges: Int
    $deviceTrackingCharges: Int!
    $billingStartFrom: String
    $billingPayTill: String
    $bucketName: String
    $fileName: String
    $GST: Float!
  ) {
    addSubscriptions(
      clientLoginId: $clientLoginId
      partnerLoginId: $partnerLoginId
      billingFrequencyId: $billingFrequencyId
      deviceModelId: $deviceModelId
      deviceQuantity: $deviceQuantity
      accessoryTypeId: $accessoryTypeId
      accessoryQuantity: $accessoryQuantity
      serviceProviderId: $serviceProviderId
      simQuantity: $simQuantity
      softwareQuantity: $softwareQuantity
      salesRemarks: $salesRemarks
      hardwareCharges: $hardwareCharges
      accessoryCharges: $accessoryCharges
      simCharges: $simCharges
      deviceTrackingCharges: $deviceTrackingCharges
      billingStartedFrom: $billingStartFrom
      billingPayTill: $billingPayTill
      bucketName: $bucketName
      fileName: $fileName
      GST: $GST
    )
  }
`
const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  input: {
    display: 'flex',
    padding: 0
  }
})

function ClientSelected(props) {
  const isClientSelected = props.isClientSelected
  if (isClientSelected) {
    return (
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <CustomerDetailsCard clientDetail={props.clientDetails} />
        </Grid>
      </Grid>
    )
  }
  return null
}

function ShowSubDetails(props) {
  const isClientSelected = props.isClientSelected

  return (
    <Fragment>
      <ConfirmationalDialog
        isDialogOpen={props.isSaveConfDialogOpen}
        dialogMessage={'Are you sure you want to Save this subscription?'}
        negativeResponseHandler={props.saveNegativeResponseHandler}
        positiveResponseHandler={props.savePositiveResponseHandler}
        isSaveBtnDisabled={props.isSaveBtnDisabled}
      />
      <ConfirmationalDialog
        isDialogOpen={props.isCancelConfDialogOpen}
        dialogMessage={
          'Are you sure you want to Cancel new subscription creation?'
        }
        negativeResponseHandler={props.cancelNegativeResponseHandler}
        positiveResponseHandler={props.cancelPositiveResponseHandler}
      />
      {isClientSelected && (
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <SubscriptionDetails
              isClientSelected={props.isClientSelected}
              clientDetails={props.clientDetails}
              isSaveButtonDisabled={
                props.billingFrequency === null ||
                props.salesRemarks === null ||
                props.billingDate === null ||
                props.totalQuantity === null ||
                props.deviceModel === null ||
                props.deviceQuantity === null ||
                props.softwareQuantity === null ||
                props.accessoryCharges === '' ||
                props.accessoryCharges === null ||
                parseInt(props.softwareQuantity, 10) === 0 ||
                parseInt(props.deviceQuantity, 10) === 0 ||
                props.gstRate === null ||
                props.hardwareCharges === null ||
                props.hardwareCharges === '' ||
                // parseInt(props.hardwareCharges, 10) === 0 ||
                props.deviceTrackingCharges === null ||
                props.deviceTrackingCharges === '' ||
                parseInt(props.deviceTrackingCharges, 10) === 0 ||
                props.gstRate === '' ||
                props.billingMode === '' ||
                props.billingFrequency === '' ||
                props.billingLogic === '' ||
                props.deviceModel === '' ||
                props.deviceQuantity === ''
              }
              isPIUploading={props.isPIUploading}
              PIFileName={props.PIFileName}
              billingMode={props.billingMode}
              billingFrequency={props.billingFrequency}
              billingFrequencies={props.billingFrequencies}
              perpetual={props.perpetual}
              billingDate={props.billingDate}
              billingDates={props.billingDates}
              gstRate={props.gstRate}
              gstRates={props.gstRates}
              deviceTrackingCharges={props.deviceTrackingCharges}
              totalAmountSoftware={props.totalAmountSoftware}
              totalAmountHardware={props.totalAmountHardware}
              totalAmountSim={props.totalAmountSim}
              totalAmountAccessory={props.totalAmountAccessory}
              billingStartFrom={props.billingStartFrom}
              billingPayTill={props.billingPayTill}
              deviceModel={props.deviceModel}
              deviceQuantity={props.deviceQuantity}
              softwareQuantity={props.softwareQuantity}
              accessoryModel={props.accessoryModel}
              accessoryQuantity={props.accessoryQuantity}
              simModel={props.simModel}
              simQuantity={props.simQuantity}
              salesRemarks={props.salesRemarks}
              simCharges={props.simCharges}
              hardwareCharges={props.hardwareCharges}
              accessoryCharges={props.accessoryCharges}
              handleDateChange={props.handleDateChange}
              handleChange={props.handleChange}
              handlePerptualCheckbox={props.handlePerptualCheckbox}
              handleSalesRemarksChange={props.handleSalesRemarksChange}
              handleSelectChange={props.handleSelectChange}
              handleSelectBillingModeChange={
                props.handleSelectBillingModeChange
              }
              handleSaveClick={props.handleSaveClick}
              handleCancelClick={props.handleCancelClick}
              handlePIUpload={props.handlePIUpload}
              handleAnnualSimChargesChange={props.handleAnnualSimChargesChange}
              handleHardwareChargesChange={props.handleHardwareChargesChange}
              handleAccessoryChargesChange={props.handleAccessoryChargesChange}
              handleGSTRateChange={props.handleGSTRateChange}
            />
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}

class NewSubscription extends Component {
  state = {
    clientId: null,
    isClientSelected: false,
    clientDetails: null,
    billingMode: null,
    billingFrequency: null,
    billingFrequencies: null,
    totalAmountSoftware: null,
    totalAmountHardware: null,
    totalAmountSim: null,
    totalAmountAccessory: null,
    deviceModel: null,
    deviceQuantity: null,
    softwareQuantity: null,
    perpetual: true,
    accessoryModel: null,
    accessoryQuantity: null,
    simModel: null,
    simQuantity: null,
    salesRemarks: null,
    deviceTrackingCharges: 0,
    simCharges: 0,
    hardwareCharges: 0,
    accessoryCharges: 0,
    isPIUploading: false,
    PIBucketName: null,
    PIFileName: null,
    // billingDates: null,
    // billingDate: null,
    gstRates: null,
    gstRate: null,
    clientsDetails: null,
    showTotalAmount: false,
    isSaveConfDialogOpen: false,
    isSaveBtnDisabled: false,
    isCancelConfDialogOpen: false,
    billingStartFrom: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    },
    billingPayTill: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    }
  }

  handlePIUpload = async ({
    target: {
      validity,
      files: [file]
    }
  }) => {
    // TODO: Handle upload errors
    this.setState({ isPIUploading: true })
    if (validity.valid) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)

      const response = await this.props.client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: {
          fileExtension
        }
      })
      if (response.data && response.data.getPublicUploadURL) {
        const url = response.data.getPublicUploadURL.publicUploadURL
        const res = await axios.put(url, file, {
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": file.type || "application/octet-stream"
          }
        })
        console.log('upload', res)
        this.setState({
          PIFileName: response.data.getPublicUploadURL.filename,
          PIBucketName: response.data.getPublicUploadURL.bucketName
        })
      }
    }
    console.log('final', this.state.PIBucketName, this.state.PIFileName)
    this.setState({ isPIUploading: false })
  }

  handleDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    tempDate.unix = moment(date)
      .unix()
      .toString()

    this.setState({ [name]: tempDate })
  }

  handleSalesRemarksChange = event => {
    this.setState({ salesRemarks: event.target.value })
  }

  handleAnnualSimChargesChange = e => {
    this.setState({ simCharges: e.target.value })
  }

  handleHardwareChargesChange = e => {
    this.setState({ hardwareCharges: e.target.value })
  }

  handleAccessoryChargesChange = e => {
    this.setState({ accessoryCharges: e.target.value })
  }

  handlePerptualCheckbox = e => {
    console.log('heeyyyeyey')
    this.setState(prev => ({
      perpetual: !prev.perpetual
    }))
  }

  handleChange = name => event => {
    if (event.target.value >= 0) {
      this.setState({ [name]: event.target.value }, () => {
        if (name === 'softwareQuantity' || name === 'deviceTrackingCharges') {
          const { softwareQuantity, deviceTrackingCharges } = this.state
          this.calculateAmount(softwareQuantity, deviceTrackingCharges, name)
        }
        if (name === 'deviceQuantity' || name === 'hardwareCharges') {
          const { deviceQuantity, hardwareCharges } = this.state
          this.calculateAmount(deviceQuantity, hardwareCharges, name)
        }
        if (name === 'accessoryQuantity' || name === 'accessoryCharges') {
          const { accessoryQuantity, accessoryCharges } = this.state
          this.calculateAmount(accessoryQuantity, accessoryCharges, name)
        }
        if (name === 'simQuantity' || name === 'simCharges') {
          const { simQuantity, simCharges } = this.state
          this.calculateAmount(simQuantity, simCharges, name)
        }
      })
    } else if (!event.target.value) {
      if (name === 'softwareQuantity' || name === 'deviceTrackingCharges') {
        this.setState({ [name]: null, totalAmountSoftware: null })
      }
      if (name === 'deviceQuantity' || name === 'hardwareCharges') {
        this.setState({ [name]: null, totalAmountHardware: null })
      }
      if (name === 'accessoryQuantity' || name === 'accessoryCharges') {
        this.setState({ [name]: null, totalAmountAccessory: null })
      }
      if (name === 'simQuantity' || name === 'simCharges') {
        this.setState({ [name]: null, totalAmountSim: null })
      }
    }
  }

  calculateAmount(quantity, charges, productPerticular) {
    let totalAmount = 0

    totalAmount = parseFloat(quantity, 10) * parseFloat(charges, 10)
    if (
      productPerticular === 'softwareQuantity' ||
      productPerticular === 'deviceTrackingCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountSoftware: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountSoftware: '' })
      }
    }

    if (
      productPerticular === 'deviceQuantity' ||
      productPerticular === 'hardwareCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountHardware: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountHardware: '' })
      }
    }

    if (
      productPerticular === 'accessoryQuantity' ||
      productPerticular === 'accessoryCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountAccessory: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountAccessory: '' })
      }
    }

    if (
      productPerticular === 'simQuantity' ||
      productPerticular === 'simCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountSim: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountSim: '' })
      }
    }
  }

  handleSelectChange = name => value => {
    if (value) {
      this.setState({ [name]: value.value }, () => {})
    } else {
      this.setState({ [name]: 0 }, () => {})
    }
  }

  setGstRateAndBillingDates = () => {
    let arrayDates = [5, 10, 15, 20]
    const billingDates = arrayDates.map(days => ({
      value: days,
      label: days + 'th'
    }))

    let gstRates = [5, 10, 12, 15, 18]
    const billingGst = gstRates.map(gst => ({
      value: gst,
      label: gst
    }))

    this.setState({
      billingDates: billingDates,
      gstRates: billingGst
    })
  }

  // handleSelectBillingModeChange = name => async value => {
  //   if (!value) {
  //     this.setState({
  //       [name]: null,
  //       billingFrequency: null,
  //       billingFrequencies: null,
  //       gstRates: null,
  //       gstRate: null,
  //       billingDate: null
  //     })
  //   } else {
  //     const billId = value

  //     const { data } = await this.props.client.query({
  //       query: GET_BILLING_FREQUENCY,
  //       variables: { billingModeId: parseInt(billId.value, 10) }
  //     })

  //     const billingFrequencies = data.getAllBillingFrequency.map(billFrq => ({
  //       value: billFrq.id,
  //       label: billFrq.frequency
  //     }))

  //     let arrayDates = [5, 10, 15, 20]
  //     const billingDates = arrayDates.map(days => ({
  //       value: days,
  //       label: days + 'th'
  //     }))

  //     let gstRates = [5, 10, 12, 15, 18]
  //     const billingGst = gstRates.map(gst => ({
  //       value: gst / 100,
  //       label: gst
  //     }))

  //     this.setState({
  //       [name]: value.value,
  //       billingFrequency: null,
  //       billingFrequencies: billingFrequencies,
  //       billingDates: billingDates,
  //       gstRates: billingGst
  //     })
  //   }
  // }

  handleClientChange = async customer => {
    let cltId = ''

    if (
      this.props.match.params.loginId === undefined ||
      this.props.match.params.loginId === ''
    ) {
      cltId = customer.value
      if (!customer) {
        this.setState({
          clientId: null,
          isClientSelected: false,
          clientDetails: null
        })
      } else {
        const { data } = await this.props.client.query({
          query: GET_CLIENT,
          variables: {
            id: parseInt(cltId, 10)
          }
        })
        this.setState({
          clientDetails: data.clientDetail,
          clientId: cltId,
          isClientSelected: true
        })
      }
    } else {
      cltId = this.props.match.params.loginId
      this.props.match.params.loginId = ''

      const { data } = await this.props.client.query({
        query: GET_CLIENT,
        variables: {
          id: parseInt(cltId, 10)
        }
      })
      this.setState({
        clientDetails: data.clientDetail,
        clientId: cltId,
        isClientSelected: true
      })
    }
  }

  handleCancelSubscription = e => {
    // this.setState({
    //   billingMode: null,
    //   billingFrequency: null,
    //   billingFrequencies: null,
    //   totalQuantity: null,
    //   totalAmount: null,
    //   deviceModel: null,
    //   deviceQuantity: null,
    //   accessoryModel: null,
    //   accessoryQuantity: null,
    //   simModel: null,
    //   simQuantity: null,
    //   grandTotalAmount: null,
    //   PIBucketName: null,
    //   PIFileName: null
    // })
    this.props.history.goBack()
  }

  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleBackCancelClick = e => {
    console.log(this.state.clientId)
    // if (
    //   this.state.clientId === null
    // ) {
    //   this.props.history.goBack()
    // } else {
    //   this.setState({ isCancelConfDialogOpen: true })
    // }
    this.state.clientId === null
      ? this.props.history.goBack()
      : this.setState({ isCancelConfDialogOpen: true })
  }

  handleSaveClick = e => {
    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
    this.setState({ isSaveBtnDisabled: false })
  }

  handleSaveSubscription = async event => {
    this.setState({ isSaveBtnDisabled: true })
    // console.log(this.state.simModel, 'acc')
    if (
      parseInt(this.state.deviceQuantity, 10) !==
      parseInt(this.state.softwareQuantity, 10)
    ) {
      this.props.openSnackbar(
        'The Software Quantity and Device Quantity Should Be Equal'
      )
    } else if (this.state.deviceQuantity < 1) {
      this.props.openSnackbar('Device quantity should be greater than 0')
    } else if (
      this.state.simModel !== null &&
      this.state.simModel !== '' &&
      (this.state.simQuantity < 1 ||
        this.state.simQuantity === null ||
        this.state.simQuantity === '')
    ) {
      this.props.openSnackbar('Select valid quantity for Sim')
    } else if (
      this.state.accessoryModel !== null &&
      this.state.accessoryModel !== '' &&
      (this.state.accessoryQuantity < 1 ||
        this.state.accessoryQuantity === null ||
        this.state.accessoryQuantity === '')
    ) {
      this.props.openSnackbar('Select valid quantity for Accessory')
      // } else if (
      //   this.state.simModel !== 0 &&
      //   this.state.simModel !== '' &&
      //   this.state.simQuantity > 0 &&
      //   (this.state.simCharges === 0 || this.state.simCharges === '')
      // ) {
      //   this.props.openSnackbar('Select valid Price for Sim')
      // }
    } else if (
      (this.state.simModel === null || this.state.simModel === '') &&
      (this.state.simQuantity > 0 ||
        (this.state.simQuantity !== null && this.state.simQuantity !== ''))
    ) {
      this.props.openSnackbar('Please Select Sim Provider')
    } else if (
      (this.state.accessoryModel === null ||
        this.state.accessoryModel === '') &&
      (this.state.accessoryQuantity > 0 ||
        (this.state.accessoryQuantity !== null &&
          this.state.accessoryQuantity !== ''))
    ) {
      this.props.openSnackbar('Please Select Accessory Model')
    } else {
      const { data } = await this.props.client.mutate({
        mutation: ADD_SUBSCRIPTION,
        variables: {
          clientLoginId: parseInt(this.state.clientId, 10),
          partnerLoginId: getLoginId(),
          billingFrequencyId: parseInt(this.state.billingFrequency, 10),
          deviceModelId: parseInt(this.state.deviceModel, 10),
          accessoryTypeId: parseInt(this.state.accessoryModel, 10),
          serviceProviderId: parseInt(this.state.simModel, 10),
          deviceQuantity: parseInt(this.state.deviceQuantity, 10),
          accessoryQuantity: parseInt(this.state.accessoryQuantity, 10),
          simQuantity: parseInt(this.state.simQuantity, 10),
          softwareQuantity: parseInt(this.state.softwareQuantity, 10),
          salesRemarks: this.state.salesRemarks,
          deviceTrackingCharges: parseInt(this.state.deviceTrackingCharges, 10),
          simCharges: parseInt(this.state.simCharges, 10),
          hardwareCharges: parseInt(this.state.hardwareCharges, 10),
          accessoryCharges: parseInt(this.state.accessoryCharges, 10),
          billingStartFrom: this.state.billingStartFrom.unix,
          billingPayTill: this.state.billingPayTill.unix,
          bucketName: this.state.PIBucketName,
          fileName: this.state.PIFileName,
          GST: parseFloat(this.state.gstRate, 10)
        }
      })

      if (data.addSubscriptions === true) {
        await this.props.client.clearStore();
        this.props.openSnackbar('Subscription Creation Successful')
        this.props.history.push({
          pathname: '/home/subscriptions/'
        })
      } else {
        this.props.openSnackbar('Subscription Creation Failed')
      }
    }
  }

  getAllClients = async () => {
    const clientsDetails = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: getLoginId()
      },
      fetchPolicy: ['network-only']
    })

    const allClients = clientsDetails.data.clients.map(client => ({
      value: client.loginId,
      label: client.clientName
    }))
    this.setState({ clientsDetails: allClients })
  }

  componentDidMount() {
    if (this.props.match.params.loginId === undefined) {
      this.getAllClients()
    } else {
      this.getAllClients()
      this.handleClientChange()
    }
    this.setGstRateAndBillingDates()
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <Grid container spacing={16} direction="row">
          <Grid item>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={this.handleBackCancelClick}
            >
              <ArrowBackIcon />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="headline">Create Subscription</Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <Select
              classes={classes}
              options={this.state.clientsDetails}
              value={this.state.clientId}
              onChange={this.handleClientChange}
              placeholder="Select Customer *"
            />
          </Grid>
          <Grid item container spacing={16} direction="row">
            <Grid item xs={12}>
              <ClientSelected
                isClientSelected={this.state.isClientSelected}
                clientDetails={this.state.clientDetails}
              />
            </Grid>
            <Grid item xs={12}>
              <ShowSubDetails
                isClientSelected={this.state.isClientSelected}
                clientDetails={this.state.clientDetails}
                isPIUploading={this.state.isPIUploading}
                isSaveConfDialogOpen={this.state.isSaveConfDialogOpen}
                isSaveBtnDisabled={this.state.isSaveBtnDisabled}
                isCancelConfDialogOpen={this.state.isCancelConfDialogOpen}
                PIFileName={this.state.PIFileName}
                billingMode={this.state.billingMode}
                billingFrequency={this.state.billingFrequency}
                billingFrequencies={this.state.billingFrequencies}
                billingDate={this.state.billingDate}
                billingDates={this.state.billingDates}
                gstRate={this.state.gstRate}
                gstRates={this.state.gstRates}
                deviceTrackingCharges={this.state.deviceTrackingCharges}
                totalAmountSoftware={this.state.totalAmountSoftware}
                totalAmountHardware={this.state.totalAmountHardware}
                totalAmountSim={this.state.totalAmountSim}
                totalAmountAccessory={this.state.totalAmountAccessory}
                billingStartFrom={this.state.billingStartFrom}
                billingPayTill={this.state.billingPayTill}
                deviceModel={this.state.deviceModel}
                deviceQuantity={this.state.deviceQuantity}
                softwareQuantity={this.state.softwareQuantity}
                perpetual={this.state.perpetual}
                accessoryModel={this.state.accessoryModel}
                accessoryQuantity={this.state.accessoryQuantity}
                simModel={this.state.simModel}
                simQuantity={this.state.simQuantity}
                salesRemarks={this.state.salesRemarks}
                handleDateChange={this.handleDateChange}
                handleSelectChange={this.handleSelectChange}
                handleChange={this.handleChange}
                handleSalesRemarksChange={this.handleSalesRemarksChange}
                simCharges={this.state.simCharges}
                hardwareCharges={this.state.hardwareCharges}
                accessoryCharges={this.state.accessoryCharges}
                handleAnnualSimChargesChange={this.handleAnnualSimChargesChange}
                handlePerptualCheckbox={this.handlePerptualCheckbox}
                handleHardwareChargesChange={this.handleHardwareChargesChange}
                handleAccessoryChargesChange={this.handleAccessoryChargesChange}
                handleGSTRateChange={this.handleGSTRateChange}
                // handleCancelSubscription={this.handleCancelSubscription}
                // handleSaveSubscription={this.handleSaveSubscription}
                handleSelectBillingModeChange={
                  this.handleSelectBillingModeChange
                }
                handlePIUpload={this.handlePIUpload}
                handleCancelClick={this.handleCancelClick}
                handleSaveClick={this.handleSaveClick}
                cancelNegativeResponseHandler={
                  this.handleCancelNegativeResponse
                }
                saveNegativeResponseHandler={this.handleSaveNegativeResponse}
                savePositiveResponseHandler={this.handleSaveSubscription}
                cancelPositiveResponseHandler={this.handleCancelSubscription}
                client={this.props.client}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  }
}

NewSubscription.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(style)(
  withSharedSnackbar(withApollo(NewSubscription))
)



// WEBPACK FOOTER //
// ./src/components/Pages/NewSubscription/index.jsx